export function InstructionBanner({ show, children }) {
    if (!show) return null;
    return (
      <div style={{ padding: 10, background: "#e0f7fa", marginBottom: 12 }}>
        {children}
      </div>
    );
  }
  